<template>
 <div  class="tz-container">
  <img class="Suspended" src="/static/image/suspended_20230504094715.png" alt="">
 </div>
</template>
<script>
export default{
        name:'',
        data () {
                return {
                        
                }
        },
        created () {
        },
        computed:{
        },
        methods:{
        }
}
</script>
<style   scoped>
 .Suspended{
    height: 930px;
 }
</style>


// WEBPACK FOOTER //
// src/components/wanhecup.vue